import SentOffersView from "../views/SentOffersView/SentOffersView";

export default function SentOffers() {
	return <SentOffersView />;
}
